import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';

import Api from "../../../libraries/api";
import { history } from "../../../shared/configure-store";
import AuthHelper from "../../../libraries/auth-helper";

require('dotenv').config();

class RegionalEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            id: '',
            name: '',
            name_in_region: '',
            email: '',
            phone: '',
            address: '',
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.validator = new SimpleReactValidator({
            messages: {
                required: 'Field ini wajib diisi'
            }
        });
    }

    componentDidMount() {
        document.title = 'Gudangemas - Ubah Keterangan Regional';
        const id = this.props.match.params.id;
        
        let profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map(o => ({
                id: o.id,
                name: o.menu.name,
                isManage: o.isManage,
            }));


            // TODO: FIX PERMISSION TO REGIONAL
            let all = roles.filter(item => item.name === 'Customer');

            this.setState({ isManage: all.length > 0 ? all[0].isManage : false });
        }

        const params = {
            page: 0,
            size: 100,
        };

        Api.post(`/region/master`, params).then(resp => {
            const data = resp.data;
            const detail = data.content && data.content.find(item => String(item.id) === id);

            if (!detail) {
                this.showMessage(false, 'Terjadi kesalahan ketika mengambil data regional');
                history.push('/regional');
                return;
            }

            this.setState({
                id: detail.id || null,
                code: detail.code || '',
                name: detail.name || '',
                description: detail.description || '',
                loading: false
            });
        }).catch(err => console.log(err));
    }

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });
    
    handleSubmit = (e) => {
        e.preventDefault();
        if (!this.validator.allValid()) {
            this.setState({ errors: this.validator.getErrorMessages() });
            return;
        }

        this.setState({ loadingButton: true });
        const params = {
            id: this.state.id,
            name: this.state.name,
            description: this.state.description,
        };

        Api.put(`/region/master`, params)
            .then((resp) => {
                if (resp.status === 200 || resp.status === 202) {
                    history.push('/regional');
                    this.showMessage(true, 'Detail regional berhasil diubah');
                } else {
                    this.showMessage(false, 'Gagal memperbarui detail regional');
                    this.setState({ loadingButton: false });
                    return;
                }
            })
            .catch(() => {
                this.showMessage(false, 'Gagal memperbarui detail regional');
                this.setState({ loadingButton: false });
            });
    };

    render() {
        this.validator.purgeFields();
        return (
            <>
                <div className="row main-content">
                    <div className="col-12">
                        <h1 className="page-title">Detail Regional</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/regional">Regional</Link></li>
                                <li className="breadcrumb-item active">Ubah</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-12">
                        <div className="table-wrapper">
                            <div className="row align-items-center content-title">
                                <div className="col-6">
                                    <h2 className='mb-0'>Ubah Detail Regional</h2>
                                </div>
                            </div>
                            <h3 className='section-title'> </h3>
                            <form onSubmit={this.handleSubmit}noValidate>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Kode Regional</label>
                                            <div className="">{this.state.code}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Nama</label>
                                            <TextField
                                                variant="outlined"
                                                value={this.state.name}
                                                onChange={(e) => this.handleChange(e, 'name')}
                                                error={this.state.errors.name}
                                                helperText={this.state.errors.name}
                                                fullWidth
                                                required
                                            />
                                            {this.validator.message('name', this.state.name, 'required')}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Keterangan</label>
                                            <TextField
                                                variant="outlined"
                                                value={this.state.description}
                                                onChange={(e) => this.handleChange(e, 'description')}
                                                error={this.state.errors.description}
                                                helperText={this.state.errors.description}
                                                rows={3}
                                                fullWidth
                                                multiline
                                                required
                                            />
                                            {this.validator.message('description', this.state.description, 'required')}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 text-center mt-4">
                                        <Button 
                                            variant="contained" 
                                            onClick={() => history.push('/regional')}
                                            className="mr-3"
                                        >
                                            Batal
                                        </Button>
                                        {this.state.isManage && (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                type="submit"
                                                disabled={this.state.loadingButton}
                                            >
                                                Simpan
                                                {this.state.loadingButton && <span className="ml-2 spinner-border spinner-border-sm" />}
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </>
        );
    }
}

export default RegionalEdit;